import { isEmbedded } from "config";

export const isPlugin = isEmbedded();
